import { createContext, useContext } from "react"

import type { CreatedBusinessPartnerSelection } from "~/utils/zod/apply-created-business-partner-selection"

export type BusinessPartnerCreatedHandler = (
  selection: CreatedBusinessPartnerSelection
) => void

export type SchemaFormNestedViewContextValue = {
  readonly isBusinessPartnerCreateHosted: boolean
  readonly openCreateBusinessPartnerView: () => void
  readonly registerBusinessPartnerCreatedHandler: (
    handler: BusinessPartnerCreatedHandler
  ) => () => void
}

const SchemaFormNestedViewContext =
  createContext<SchemaFormNestedViewContextValue | null>(null)

export const SchemaFormNestedViewProvider = ({
  value,
  children,
}: {
  readonly value: SchemaFormNestedViewContextValue
  readonly children: React.ReactNode
}): JSX.Element => {
  return (
    <SchemaFormNestedViewContext.Provider value={value}>
      {children}
    </SchemaFormNestedViewContext.Provider>
  )
}

export const useSchemaFormNestedViewContext =
  (): SchemaFormNestedViewContextValue | null => {
    return useContext(SchemaFormNestedViewContext)
  }
